import styled from 'styled-components';
import { Tabs } from 'antd';

export const TabsSContainer = styled.div`
  background: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.backgroundLightGrey};
  border-radius: 5px;
  margin-bottom: 25px;
  
  .ant-tabs-top-content {
    position: relative;
    min-height: 100px;
    padding: ${({ padding }) => padding || '16px 14px'};
  }
`;

export const TabsS = styled(Tabs)`
  overflow: unset;

  .ant-tabs-bar {
    border-bottom: none;
    margin: 0;
  }
  
  .ant-tabs-nav {
    width: 100%;
    border-bottom: 2px solid ${props => props.theme.colors.backgroundLightGrey};
  }
  
  .ant-tabs-nav > div {
    display: flex;
  }

  .ant-tabs-nav div.ant-tabs-tab {
    font-weight: 400;
    color: ${props => props.theme.colors.secondaryDark};
    border-bottom: 1px solid transparent;
    transition: border-color 0.2s ease-in-out;
    text-align: center;
    margin: 0;
    padding: 14px;
    width: 100%;

    &:hover {
      background-color: ${props => props.theme.colors.backgroundLightGray};  
    }
  }

  .ant-tabs-nav div.ant-tabs-tab-active {
    color: ${props => props.theme.colors.mainDark};
    font-weight: 500;
  }

  .ant-tabs-ink-bar {
    background-color: ${props => props.theme.colors.mainDark};
    height: 4px;
    margin-top: -4px;
    position: static;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ui-helpers/tabs.js